module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_features_02-edbdd305cc03178a431deb4a5a5a02ea.png";